const WEEKS = [
  { wk: "第 36 期", range: "09.01 - 09.07", count: "48 条", peak: "顶流恋情", heat: "312w", top: true },
  { wk: "第 35 期", range: "08.25 - 08.31", count: "41 条", peak: "综艺剪辑事故", heat: "201w", top: false },
  { wk: "第 34 期", range: "08.18 - 08.24", count: "37 条", peak: "带货一哥翻车", heat: "176w", top: false },
  { wk: "第 33 期", range: "08.11 - 08.17", count: "33 条", peak: "颁奖礼同框", heat: "142w", top: false },
];

const TOPICS = [
  { name: "圈内 · 恋情", n: 16, color: "bg-primary-500" },
  { name: "商界 · 人事", n: 9, color: "bg-accent-500" },
  { name: "综艺 · 录制", n: 8, color: "bg-secondary-600" },
  { name: "网红 · 带货", n: 7, color: "bg-accent-400" },
  { name: "体育 · 言论", n: 5, color: "bg-primary-300" },
  { name: "音乐 · 现场", n: 3, color: "bg-secondary-500" },
];

export default function Monthly() {
  return (
    <section id="monthly" className="py-10 md:py-14 bg-background-100/60">
      <div className="mx-auto max-w-[1240px] px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-[320px_1fr] gap-6">
          {/* 本月大字索引 */}
          <div className="lg:sticky lg:top-24 h-fit">
            <div className="bg-primary-500 rounded-lg p-6 md:p-7 text-background-50 overflow-hidden">
              <p className="text-[13px] font-semibold tracking-wide text-background-100/80">MONTHLY DOSSIER</p>
              <div className="mt-3 flex items-end gap-1">
                <span className="font-heading text-[72px] leading-none font-black">09</span>
                <span className="pb-2 text-xl font-semibold text-accent-200">月</span>
              </div>
              <h2 className="mt-3 font-heading text-[24px] font-black leading-tight">本月黑料新近合集</h2>
              <p className="mt-3 text-[13.5px] leading-relaxed text-background-100/90">
                9 月已归档 <b className="text-accent-300">4 期 · 159 条</b> 事件。这份新近合集按月收束，回看当月热点不用四处翻。
              </p>
              <a
                href="#timeline"
                className="mt-5 inline-flex items-center gap-2 rounded-md bg-background-50 text-primary-700 px-4 py-2 text-sm font-bold hover:bg-accent-200 whitespace-nowrap"
              >
                补课上月时间线 <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center" />
              </a>
            </div>

            {/* 题材分布 */}
            <div className="mt-4 bg-background-50 rounded-lg border border-background-200 p-5">
              <h3 className="font-heading text-[16px] font-bold text-foreground-950 mb-4 flex items-center gap-2">
                <i className="ri-pie-chart-2-line w-4 h-4 text-primary-500 flex items-center justify-center" />
                本月题材占比
              </h3>
              <div className="space-y-3">
                {TOPICS.map((t) => (
                  <div key={t.name} className="flex items-center gap-3">
                    <span className="w-24 shrink-0 text-[12.5px] text-foreground-700">{t.name}</span>
                    <div className="flex-1 h-2 rounded-full bg-background-200 overflow-hidden">
                      <div className={`h-full rounded-full ${t.color}`} style={{ width: `${(t.n / 16) * 100}%` }} />
                    </div>
                    <span className="w-6 text-right text-[12px] font-semibold text-foreground-500">{t.n}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* 每周合集列表 */}
          <div>
            <div className="flex items-center justify-between mb-4">
              <h2 className="font-heading text-[22px] md:text-[26px] font-black text-foreground-950">本周起倒序索引</h2>
              <span className="text-[13px] text-foreground-400">共 4 期 · 每周日 22:00 更新</span>
            </div>
            <div className="space-y-3">
              {WEEKS.map((w) => (
                <a
                  key={w.wk}
                  href="#recap"
                  className={`group flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-0 rounded-lg border p-4 md:p-5 transition-all hover:-translate-y-0.5 ${
                    w.top
                      ? "bg-accent-50 border-accent-200"
                      : "bg-background-50 border-background-200 hover:border-accent-200"
                  }`}
                >
                  <div className="w-full sm:w-44 shrink-0">
                    <div className="flex items-center gap-2">
                      <span className={`font-heading text-[18px] font-black ${w.top ? "text-accent-700" : "text-foreground-900"}`}>
                        {w.wk}
                      </span>
                      {w.top && (
                        <span className="rounded-full bg-accent-500 text-background-50 px-2 py-0.5 text-[11px] font-bold">最新</span>
                      )}
                    </div>
                    <p className="mt-1 text-[12.5px] text-foreground-500">{w.range}</p>
                  </div>
                  <div className="flex-1 sm:px-4 flex items-center gap-3">
                    <span className="w-10 h-10 rounded-md bg-background-100 flex items-center justify-center font-heading text-[15px] font-bold text-primary-600">
                      {w.count.replace(" 条", "")}
                    </span>
                    <div>
                      <p className="text-[13px] text-foreground-500">本周峰值话题</p>
                      <p className="text-[14.5px] font-semibold text-foreground-900">{w.peak}</p>
                    </div>
                  </div>
                  <div className="sm:w-28 flex items-center gap-1 text-[13px] text-foreground-600">
                    <i className="ri-fire-line w-4 h-4 text-accent-500 flex items-center justify-center" /> {w.heat}
                  </div>
                  <div className="sm:w-8 flex sm:justify-end">
                    <i className="ri-arrow-right-s-line w-6 h-6 text-foreground-300 group-hover:text-accent-600 transition-colors flex items-center justify-center" />
                  </div>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}